var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRush(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64288 0.178571C6.57947 0.0714286 6.48434 0 6.35751 0H2.55252C2.42568 0 2.33056 0.0714286 2.26714 0.178571L0.0475624 4.82143C-0.0158541 4.92857 -0.0158541 5.07143 0.0475624 5.17857C0.110979 5.28571 0.206104 5.35714 0.332937 5.35714H1.7281L0.0475624 9.5C-0.0158541 9.64286 0.0158542 9.82143 0.142687 9.92857C0.174396 9.96429 0.26952 10 0.332937 10C0.396354 10 0.45977 9.96429 0.523187 9.92857L6.23068 5.28571C6.35751 5.17857 6.38922 5.03571 6.35751 4.89286C6.3258 4.75 6.19897 4.64286 6.04043 4.64286H4.67697L6.64288 0.535714C6.67459 0.428571 6.67459 0.285714 6.64288 0.178571Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRush);
export default __webpack_public_path__ + "static/media/rush.59801357.svg";
export { ForwardRef as ReactComponent };